import { Component } from '@angular/core';
import { SanitizerPipe } from '../../pipes';

@Component({
    selector: 'app-account-on-hold-simple',
    standalone: true,
    imports: [SanitizerPipe],
    templateUrl: './account-on-hold-simple.component.html',
    styleUrl: './account-on-hold-simple.component.scss',
})
export class AccountOnHoldSimpleComponent {}
